function toPascalKey(key, keyOverrides) {
  if (!key) return key
  return keyOverrides[key] ?? key.charAt(0).toUpperCase() + key.slice(1)
}

/**
 * Recursively converts camelCase keys to PascalCase for legacy UI consumers.
 * Already-PascalCase keys are unchanged. Pass keyOverrides for domain-specific acronyms.
 */
export function convertKeysToPascalCase(value, keyOverrides = {}) {
  if (value === null || value === undefined) {
    return value
  }

  if (Array.isArray(value)) {
    return value.map((item) => convertKeysToPascalCase(item, keyOverrides))
  }

  if (typeof value === 'object') {
    if (value instanceof Date) {
      return value
    }

    return Object.entries(value).reduce((acc, [key, nestedValue]) => {
      acc[toPascalKey(key, keyOverrides)] = convertKeysToPascalCase(
        nestedValue,
        keyOverrides
      )
      return acc
    }, {})
  }

  return value
}
